import { render, staticRenderFns } from "./fertigerComponent.vue?vue&type=template&id=4d284780&scoped=true"
import script from "./fertigerComponent.vue?vue&type=script&lang=js"
export * from "./fertigerComponent.vue?vue&type=script&lang=js"
import style0 from "./fertigerComponent.vue?vue&type=style&index=0&id=4d284780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d284780",
  null
  
)

export default component.exports